import { GoalTemplate } from '@griply/types';
import { createContext } from 'react';

export type GoalTemplatePreviewContextProps = {
  openGoalTemplatePreview: (template: GoalTemplate) => void;
};

export const GoalTemplatePreviewContext =
  createContext<GoalTemplatePreviewContextProps>({
    openGoalTemplatePreview: () => {},
  });
